module.exports = __webpack_public_path__ + "static/media/Sweet Dough.e822a976.jpg";